import { create } from 'zustand';

import ILayerDashboardAttributeModel from '../model/ILayerDashboardAttributeModel';
import { ILayerDashboard, ILayerGroupDashboardSummary } from '../model/ILayerDashboardMainResponse';

export interface IUseLayerDashboardStore {
    attributes: ILayerDashboardAttributeModel[];
    clear: () => void,
    recalculate: () => void,
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    data: any[],
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    displayableData: any[],
    selectedData: any[],
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    jsonConfig: {[key: string]: any},
    layerSource: string;
    maximizedView: string;
    setMaximizedView: (value: string) => void,
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    setDisplayableData: (value: any[]) => void,
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    setSelectedData: (value: any[]) => void,
    setResponse: (value: ILayerDashboard|undefined) => void,
    title: string;
}

export const createLayerDashboardTabStore = () => {
    return create<IUseLayerDashboardStore>()(
        (set, get) => ({
            attributes: [],
            clear: () => set({
                selectedData: [],
                displayableData: get().data
            }),
            data: [],
            displayableData: [],
            selectedData: [],
            jsonConfig: {},
            layerSource: '',
            maximizedView: '',
            setMaximizedView: (value: string) => set({
                maximizedView: value
            }),
            recalculate: () => set({
                displayableData: get().selectedData,
                selectedData: [],
            }),
            /* eslint-disable  @typescript-eslint/no-explicit-any */
            setDisplayableData: (value: any[]) => set({
                displayableData: value
            }),
            /* eslint-disable  @typescript-eslint/no-explicit-any */
            setSelectedData: (value: any[]) => set({
                selectedData: value
            }),
            setResponse: (value: ILayerDashboard|undefined) => set({
                attributes: value?.Attributes,
                data: value?.Data.map((x: any) => JSON.parse(x)),
                displayableData: value?.Data.map((x: any) => JSON.parse(x)),
                jsonConfig: value?.JsonConfig,
                layerSource: value?.LayerSource,
                title: value?.Title,
            }),
            title: 'Carregando...',
        })
    );
};

export type LayerDashboardTabStore = ReturnType<typeof createLayerDashboardTabStore>;